import { gql } from "@grandvisionhq/graphql";
const UPDATE_PERSONAL_DETAILS = gql`
  mutation updatePersonalDetails($customerId: ID!, $input: PersonalDetailsB2CUpdateInput!) {
    updateB2CPersonalDetails(customerId: $customerId, input: $input) {
      id
      preferredStore {
        globalStoreId
      }
    }
  }
`;
export {
  UPDATE_PERSONAL_DETAILS
};
//# sourceMappingURL=update-personal-details.js.map
